// Side-effect module: calling initSentry() at module evaluation time.
//
// MUST be the first `import` in `app/_layout.tsx` — ES modules execute
// imports in source order before any body code runs, so importing this
// module first guarantees Sentry.init() completes before any subsequent
// import-time side effects (Branch SDK, RudderStack, CustomerIO,
// SplashScreen, etc.) get a chance to throw.
//
// Why this matters: a fatal JS error during early boot can kill the
// process before Sentry's network upload completes. The earlier the
// global error handler is installed, the more of those early errors we
// can persist and capture.
import { initSentry } from "./index";

initSentry();
